<h1 mat-dialog-title>{{title}}
  <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
  </sfc-icon>
</h1>
<div mat-dialog-content>
  <div *ngIf='hasData ; else errorTextField'>
      <ng-container #mandatesTable></ng-container>
  </div>
</div>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
